[
  {
    "id": "019b1203-5d28-73b3-849d-375144db5ab8",
    "scanDate": "2025-12-11T12:00:00Z",
    "floor": 1
  }
]